var map = {
	"./": 211,
	"./Clutch": 485,
	"./Clutch/": 485,
	"./Clutch/index": 485,
	"./Clutch/index.js": 485,
	"./Clutch/style": 1123,
	"./Clutch/style.js": 1123,
	"./NewUi": 486,
	"./NewUi/": 486,
	"./NewUi/index": 486,
	"./NewUi/index.js": 486,
	"./NewUi/style": 1124,
	"./NewUi/style.js": 1124,
	"./OldUi": 487,
	"./OldUi/": 487,
	"./OldUi/index": 487,
	"./OldUi/index.js": 487,
	"./OldUi/style": 1125,
	"./OldUi/style.js": 1125,
	"./SpireonNew": 488,
	"./SpireonNew/": 488,
	"./SpireonNew/index": 488,
	"./SpireonNew/index.js": 488,
	"./SpireonNew/style": 1126,
	"./SpireonNew/style.js": 1126,
	"./SpireonOld": 489,
	"./SpireonOld/": 489,
	"./SpireonOld/index": 489,
	"./SpireonOld/index.js": 489,
	"./SpireonOld/style": 1127,
	"./SpireonOld/style.js": 1127,
	"./index": 211,
	"./index.js": 211,
	"./style": 222,
	"./style.js": 222
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 4179;
module.exports = webpackAsyncContext;